import { createContext } from 'react';

export const OverlayContext = createContext<any>(false);